// #580: Schalter „Objekt im Ticket-Titel“ (app_settings 'ticket_titel_objekt', Standard an).
// Ausgewertet vom DB-Trigger tickets_titel_objekt (Migration 2026-10-29-ticket-titel-objekt.sql).
import { supabase } from '../supabase/client';

export const SCHALTER_TICKET_TITEL_OBJEKT = 'ticket_titel_objekt';

export async function ladeSchalterTicketTitelObjekt(): Promise<boolean> {
  const { data, error } = await supabase.from('app_settings').select('value').eq('key', SCHALTER_TICKET_TITEL_OBJEKT).maybeSingle();
  if (error) throw error;
  return (data?.value as { aktiv?: boolean } | null)?.aktiv !== false;
}

export async function setzeSchalterTicketTitelObjekt(aktiv: boolean): Promise<void> {
  const { error } = await supabase.from('app_settings')
    .upsert({ key: SCHALTER_TICKET_TITEL_OBJEKT, value: { aktiv }, updated_at: new Date().toISOString() }, { onConflict: 'key' });
  if (error) throw error;
}
